import React from "react";

// Lightweight drop-in replacement for framer-motion's `motion.*` used on the
// landing page. Strips animation props and applies a CSS fade/rise-in so the
// heavy framer-motion library stays out of the main (eager) bundle.
const STRIP = new Set(["initial", "animate", "exit", "whileInView", "whileHover", "whileTap", "viewport", "transition", "variants", "layout", "layoutId"]);

const make = (Tag) =>
  React.forwardRef(function M({ transition, style, className = "", ...rest }, ref) {
    const props = {};
    for (const k in rest) if (!STRIP.has(k)) props[k] = rest[k];
    const delay = transition && typeof transition.delay === "number" ? transition.delay : 0;
    return (
      <Tag
        ref={ref}
        className={`mo-rise ${className}`}
        style={{ ...style, animationDelay: delay ? `${delay}s` : undefined }}
        {...props}
      />
    );
  });

export const motion = new Proxy({}, { get: (_t, tag) => make(tag) });
